
import { grey } from 'material-ui/colors';

export const landingButton = {
    backgroundColor:'#fff',
    color:'#1d7a71',
    fontSize:'1.75rem',
    letterSpacing: '0.1em'
};
export const stepButton = {
    backgroundColor:'#1d7a71',
    color:'#fff',
    fontSize:'1.25rem'
};
export const projectSelectedStyle = {
    border: '3px solid #1d7a71',
    padding: '10px'
}

export const indicatorTab = {
    backgroundColor:'#1d7a71'
};

export const backButton = {backgroundColor:'#f2f2f2',color:'rgba(0,0,0,0.57)',fontSize:'1.25rem'};

export const bgHeader = grey[50];

export const changeProject = {
    backgroundColor:'rgba(0,0,0,0)',
    color:'#33877f',
    fontSize:'2.1rem',
    fontFamily: 'DB Heavent Med',
    letterSpacing: 2.2,
    padding: '20px 0 0',
    // width:'100%'
};

export const gotoProject = {
    backgroundColor:'rgba(0,0,0,0)',
    color:'#33877f',
    fontSize:'2.1rem',
    fontFamily: 'DB Heavent Med',
    letterSpacing: 2.2,
    width:'100%'
};

export const gotoProjectButton = {
    backgroundColor:'rgba(0,0,0,0)',
    color:'#ffffff',
    fontSize:'2.1rem',
    fontFamily: 'DB Heavent',
    letterSpacing: 2.2,
    width:'75%',
    border: '1px solid #ffffff',
};

/// summary card
export const kwPercent = '#FFEB3B';

/// footer calculator
export const calButton = {backgroundColor:'rgba(0,0,0,0)',color:'#FAFAFA',fontSize:'1.2rem',border: '1px solid'};




// WEBPACK FOOTER //
// ./src/constants/theme.js